module.exports = __webpack_public_path__ + "img/location-shenzhen.edd8b233.png";